import { css } from 'styled-components';
import { rem, media } from '../../../helpers/mixins';
import {
  PURPLE_LIGHT, GRAY, PURPLE_LIGHTER, SEARCH_HIGHLIGHT, PINK
} from '../../../constants/colors';

export default {
  wrapper: css`
  padding-bottom: 45px;

    .searchHighlight {
      position: relative;

      &:after {
        content: '';
        position: absolute;
        width: calc(100% + 8px);
        height: 100%;
        top: 0;
        left: -6px;
        background-color: ${SEARCH_HIGHLIGHT};
        z-index: -1;
        border-radius: 2px;
      }
    }
  `,
  searchWrapper: css`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 64px;
  `,
  searchInputWrapper: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid ${GRAY};
  `,
  searchInput: css`
    min-width: 300px;
    width: 100%;
    max-width: 400px;
    border: 0;
    outline: 0;
    color: ${PURPLE_LIGHT};
    font-size: ${rem('20px')};

    &::placeholder {
      color: ${PURPLE_LIGHTER};
    }
  `,
  searchIcon: css`
    width: 12px;
    height: 12px;
  `,
  categoryWrapper: css`
    display: flex;
    border-bottom: 1px solid ${GRAY};
    justify-content: space-between;
    cursor: pointer;
  `,
  categoryTitle: ({ hasIcon }) => css`
    display: flex;
    align-items: baseline;
    font-size: ${rem('24px')};
    color: ${PURPLE_LIGHT};
    padding: 44px 0 22px;

    ${media.sm`
      font-size: ${rem('30px')};
      ${hasIcon && css`
        padding: 64px 0 42px;
      `}
    `}
  `,
  categoryIcon: css`
    width: auto;
    height: 38px;
    margin-right: 8px;

    ${media.sm`
      height: max-content;
      margin-right: 16px;
    `}
  `,
  questionWrapper: props => css`
    display: block;
    overflow: hidden;
    transition: all 0.3s ease-out;
    will-change: auto;
    max-height: 0;

    ${props.isActive && css`
      will-change: max-height;
      transition: max-height 0.3s ease-in-out;
      max-height: 100%;
    `};
  `,
  question: ({ isActive }) => css`
    transform: translate3d(0, 30px, 0);
    transition: all 0.3s ease-out;
    will-change: auto;
    padding: 16px 0;
    font-size: ${rem('14px')};
    opacity: 0;

    ${isActive && css`
      will-change: transform, opacity;
      opacity: 1;
      transition: opacity 0.25s ease-out, transform 0.25s ease-out;
      transform: translate3d(0, 0, 0);
    `};

    ${media.sm`
      font-size: ${rem('16px')};
    `}
  `,
  noResults: css`
    display: flex;
    flex: 1;
    color: black;
    background-color: ${SEARCH_HIGHLIGHT};
    margin-top: 44px;
    justify-content: center;
    padding: 24px 16px;
    font-size: ${rem('16px')};
    border-radius: 5px;

    ${media.sm`
      margin-top: 64px;
      font-size: ${rem('20px')};
    `}
  `,
  seeMoreQuestions: css`
    display: block;
    font-size: ${rem('14px')};
    color: ${PINK};
    text-decoration: underline;
    padding-top: 24px;

    &:hover {
      color: ${PINK};
      text-decoration: underline;
      opacity: 0.8;
    }
  `
};
